import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../layout/theme-next/provider';
import Colors from '../../../layout/theme/utils/colors';

export default makeStyles<NextTheme>((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    lineHeight: 1.25,
    color: Colors.white,
    marginRight: theme.spacing(2),
  },
  icon: {
    marginRight: theme.spacing(1),
  },
}));
